import { FREELANCECLIENTCERTIFICATE } from "../../ENVIRONMENT";

// api for freelance client certificate list
function freecertificateList(token) {
  const response = fetch(FREELANCECLIENTCERTIFICATE, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${
        token ? token : sessionStorage.getItem("token")
      }`,
    },
  });
  return response;
}

export { freecertificateList };
